import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  sv: {
    translation: {
      login: {
        title: "Logga in",
        phoneLabel: "Telefonnummer",
        phonePlaceholder: "Telefonnummer",
        passwordLabel: "Lösenord",
        passwordPlaceholder: "Ange ditt lösenord",
        signIn: "Logga in",
        forgotPassword: "Glömt lösenordet?",
        noAccount: "Har du inget konto?",
        signUp: "Registrera dig",
      },
      signUp: {
        title: "Ange och verifiera telefonnummer",
        subtitle: "Vi skickar en bekräftelsekod via SMS till din telefon",
        phoneLabel: "Telefonnummer",
        phonePlaceholder: "Telefonnummer",
        continue: "Fortsätt",
        haveAccount: "Har du redan ett konto?",
        signIn: "Logga in",
      },
      otp: {
        title: "Verifiera SMS-koden",
        subtitle: "Ange den 4-siffriga koden som skickades till ditt telefonnummer",
        continue: "Fortsätt",
        resendCode: "Skicka kod igen",
        codeResent: "Koden har skickats igen",
      },
      userInfo: {
        title: "Snart klar",
        subtitle: "Fyll i dina uppgifter för att slutföra registreringen",
        nameLabel: "Förnamn",
        namePlaceholder: "Ange ditt förnamn",
        surnameLabel: "Efternamn",
        surnamePlaceholder: "Ange ditt efternamn",
        passwordLabel: "Lösenord",
        passwordPlaceholder: "Ange ditt lösenord",
        confirmPasswordLabel: "Bekräfta lösenord",
        confirmPasswordPlaceholder: "Bekräfta ditt lösenord",
        finish: "Slutför",
        haveAccount: "Har du redan ett konto?",
        signIn: "Logga in",
      },
      forgotPassword: {
        title: "Ange ditt telefonnummer",
        subtitle: "Vi skickar en bekräftelsekod via SMS till din telefon",
        phoneLabel: "Telefonnummer",
        phonePlaceholder: "Telefonnummer",
        continue: "Fortsätt",
        backToLogin: "Tillbaka till inloggning",
      },
      resetPassword: {
        title: "Återställ lösenord",
        subtitle: "Ange din nya lösenord",
        passwordLabel: "Nytt lösenord",
        passwordPlaceholder: "Ange ditt nya lösenord",
        confirmPasswordLabel: "Bekräfta nytt lösenord",
        confirmPasswordPlaceholder: "Bekräfta ditt nya lösenord",
        continue: "Återställ lösenord",
      },
      navbar: {
        logout: "Logga ut",
        login: "Logga in",
      },
      bookings: {
        none: "Inga bokningar tillgängliga",
      },
      bookingCard: {
        yourBookings: "Dina bokningar",
        bookNewSlot: "Boka ny tid",
        deleteAria: "Ta bort bokning",
        confirmDelete: "Är du säker på att du vill ta bort den här bokningen?",
      },
      notFound: {
        title: "Sidan hittas inte",
        description: "Tyvärr, sidan du letar efter finns inte.",
        home: "Gå till startsidan",
      },
      bookSlot: {
        title: "Boka din tid",
        subtitle: "Välj ett datum för att visa och boka tillgängliga tider",
        propertyDescription:
          "Klicka på ett markerat datum för att se tillgängliga tider",
        legend: {
          available: "Tillgänglig",
          today: "Idag",
          past: "Förflutet/Inte tillgänglig",
        },
        errorTitle: "Bokningen misslyckades",
        errorBack: "Gå tillbaka",
        successTitle: "Bokning bekräftad!",
        successBookAnother: "Boka en till",
        successViewBookings: "Visa mina bokningar",
        emptyTitle: "Inga tider tillgängliga",
        emptyDescription:
          "Det finns inga tillgängliga tider just nu. Vänligen försök senare.",
      },
      availableTimes: {
        title: "Tillgängliga tider",
        noSlots: "Inga tider tillgängliga för detta datum",
        bookSelected: "Boka vald tid",
        closeAria: "Stäng",
      },
      calendar: {
        months: [
          "Januari",
          "Februari",
          "Mars",
          "April",
          "Maj",
          "Juni",
          "Juli",
          "Augusti",
          "September",
          "Oktober",
          "November",
          "December",
        ],
        daysShort: ["Sön", "Mån", "Tis", "Ons", "Tors", "Fre", "Lör"],
      },
    },
  },
  en: {
    translation: {
      login: {
        title: "Login",
        phoneLabel: "Phone Number",
        phonePlaceholder: "Phone number",
        passwordLabel: "Password",
        passwordPlaceholder: "Enter your password",
        signIn: "Sign In",
        forgotPassword: "Forgot password?",
        noAccount: "Don't have an account?",
        signUp: "Sign Up",
      },
      signUp: {
        title: "Enter and verify phone number",
        subtitle: "We will send a confirmation code via SMS to your phone",
        phoneLabel: "Phone Number",
        phonePlaceholder: "Phone number",
        continue: "Continue",
        haveAccount: "Already have an account?",
        signIn: "Sign In",
      },
      otp: {
        title: "Verify the SMS code",
        subtitle: "Enter the 4-digit code sent to your phone number",
        continue: "Continue",
        resendCode: "Resend code",
        codeResent: "Code has been resent",
      },
      userInfo: {
        title: "Ready Soon",
        subtitle: "Fill in your details to complete registration",
        nameLabel: "First Name",
        namePlaceholder: "Enter your first name",
        surnameLabel: "Last Name",
        surnamePlaceholder: "Enter your last name",
        passwordLabel: "Password",
        passwordPlaceholder: "Enter your password",
        confirmPasswordLabel: "Confirm Password",
        confirmPasswordPlaceholder: "Confirm your password",
        finish: "Finish",
        haveAccount: "Already have an account?",
        signIn: "Sign In",
      },
      forgotPassword: {
        title: "Enter Your Phone",
        subtitle: "We will send a confirmation code via SMS to your phone",
        phoneLabel: "Phone Number",
        phonePlaceholder: "Phone number",
        continue: "Continue",
        backToLogin: "Back to Login",
      },
      resetPassword: {
        title: "Reset Password",
        subtitle: "Enter your new password",
        passwordLabel: "New Password",
        passwordPlaceholder: "Enter your new password",
        confirmPasswordLabel: "Confirm New Password",
        confirmPasswordPlaceholder: "Confirm your new password",
        continue: "Reset Password",
      },
      navbar: {
        logout: "Logout",
        login: "Login",
      },
      bookings: {
        none: "No bookings available",
      },
      bookingCard: {
        yourBookings: "Your Bookings",
        bookNewSlot: "Book New Slot",
        deleteAria: "Delete booking",
        confirmDelete: "Are you sure you want to delete this booking?",
      },
      notFound: {
        title: "Page Not Found",
        description: "Sorry, the page you are looking for doesn't exist.",
        home: "Go Back Home",
      },
      bookSlot: {
        title: "Book Your Slot",
        subtitle: "Select a date to view and book available time slots",
        propertyDescription:
          "Click on any highlighted date to see available time slots",
        legend: {
          available: "Available",
          today: "Today",
          past: "Past/Unavailable",
        },
        errorTitle: "Booking Failed",
        errorBack: "Go Back",
        successTitle: "Booking Confirmed!",
        successBookAnother: "Book Another",
        successViewBookings: "View My Bookings",
        emptyTitle: "No Time Slots Available",
        emptyDescription:
          "There are no available booking slots at this time. Please check back later.",
      },
      availableTimes: {
        title: "Available Time Slots",
        noSlots: "No time slots available for this date",
        bookSelected: "Book Selected Slot",
        closeAria: "Close",
      },
      calendar: {
        months: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      },
    },
  },
};

const initialLng = ((): string => {
  if (typeof window === "undefined") return "sv";
  return localStorage.getItem("lng") || "sv";
})();

i18n.use(initReactI18next).init({
  resources,
  lng: initialLng,
  fallbackLng: "sv",
  interpolation: {
    escapeValue: false,
  },
});

if (typeof window !== "undefined") {
  document.documentElement.lang = initialLng;
  i18n.on("languageChanged", (lng) => {
    try {
      localStorage.setItem("lng", lng);
    } catch {
      void 0;
    }
    document.documentElement.lang = lng;
  });
}

export default i18n;


